import { memo } from 'react'
import Link from 'src/components/ui/Link'
import './card-custom.scss'

interface CardCustomProps {
  card: CardItem
}

const CardCustom = ({ card }: CardCustomProps) => {
  return (
    <div className="card-custom">
      <Link as="a" href={card.href} className="card-custom__link">
        {card?.img && (
          <img
            className="card-custom__img"
            src={card.img}
            alt={card.alt}
            loading="eager"
          />
        )}
        <h3
          className={`card-custom__title ${
            card?.description ? '' : 'without-description'
          }`}
        >
          {card.title}
        </h3>
      </Link>
      {card?.description && (
        <p className="card-custom__description">{card.description}</p>
      )}
    </div>
  )
}

export default memo(CardCustom)
